export default __webpack_public_path__ + "static/media/higher_brand_arrow.5e0a14f8.svg";